import * as React from 'react';
import { connect } from 'react-redux';
import { navigateTo } from '../../../../actions/navigationActions';
import { setIsOnQuoteScreen } from '../../../../actions/salesActions';
import { BANKING_DETAILS } from '../../../../routes/routes';
import AcceptQuote from '../../AcceptQuote/AcceptQuote';
import './CodeRedQuotation.css';

class CodeRedQuotation extends React.PureComponent<any, any> {
    constructor(props) {
        super(props);

        this.handleAcceptQuote = this.handleAcceptQuote.bind(this);
    }

    async handleAcceptQuote() {
        await this.props.dispatchAction(setIsOnQuoteScreen(false, "", ""));
        await this.props.dispatchAction(navigateTo(BANKING_DETAILS))
    }

    public render() {
        return (
            <div className="container text-center pt-lg-5 p-lg-0 logged-in expand-dropdown">
                {/*Desktop view*/}
                <div className="GetCodeRedBanner d-none d-sm-flex">
                    <div className="code-red-banner-content" >
                        <div>
                            <div className="code-red-banner-text-title">
                                Code red
                            </div>
                            <div className="mt-8px">
                                Personal safety assistance
                            </div>
                        </div>
                    </div>
                    <div className="code-red-banner-content" style={{ float: 'right' }} >
                        <div className="code-red-banner-content-detail" >
                            <div className="text-center" style={{ width: '100%' }}>
                                <div className="code-red-banner-text-premium">
                                    Monthly premium
                                </div>
                                <div className="code-red-banner-text-amount">
                                    {this.props.profile.currencySymbol} {this.props.sales.carPremium}
                                </div>
                                <button className="btn btn-block btn-solid-green button-width btn btn-primary mt-16px" onClick={this.handleAcceptQuote}>Add to quote</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/*Mobile view*/}
                <div className="GetCodeRedBanner code-red-banner-mobile d-sm-none d-xs-block" >
                    <div className="code-red-banner-text-title">Code red</div>
                    <div className="mt-8px">Personal safety assistance</div>
                    <div className="code-red-banner-mobile-devider mt-8px"></div>
                    <div className="code-red-banner-text-premium mt-8px">My monthly premium</div>
                    <div className="code-red-banner-text-amount-big mt-8px">{this.props.profile.currencySymbol} {this.props.sales.carPremium}</div>
                </div>
                {/*Quote detail*/}
                <div className="code-red-quote-detail text-left">
                    <div className="label">Your details</div>
                    <div className="row">
                        <div className="col-6">Name</div>
                        <div className="col-6 code-red-quote-detail-text">{this.props.sales.name}</div>
                    </div>
                    <div className="row">
                        <div className="col-6">Surname</div>
                        <div className="col-6 code-red-quote-detail-text">{this.props.sales.surname}</div>
                    </div>
                    <div className="row">
                        <div className="col-6">Contact no.</div>
                        <div className="col-6 code-red-quote-detail-text">{this.props.sales.cellphoneNumber}</div>
                    </div>
                    {this.props.sales.vehicleFullDescription !== "" &&
                        <>
                            <div className="row">
                            <div className="col-6">Vehicle</div>
                            {this.props.sales.vehicleFullDescription.length > 50 &&
                            <div className="col-6 code-red-quote-detail-text">{this.props.sales.vehicleFullDescription.substring(0, 50)}...</div>
                            }
                            {this.props.sales.vehicleFullDescription.length <= 50 &&
                                <div className="col-6 code-red-quote-detail-text">{this.props.sales.vehicleFullDescription}</div>
                            }
                            </div>
                            <div className="row">
                                <div className="col-6">Colour</div>
                            <div className="col-6 code-red-quote-detail-text">{this.props.sales.carColor.description}</div>
                            </div>
                            <div className="row">
                                <div className="col-6">Reg no.</div>
                            <div className="col-6 code-red-quote-detail-text">{this.props.sales.regNr}</div>
                            </div>
                        </>
                    }
                </div>
                <p className="Overview-only-Pleas mt-20px">
                    Overview only. Please refer to our <a target="_blank" href="/Content/documents/King-price-insurance-policy.pdf">KPPD</a> and your policy schedule for more info.
                </p>
                {/*Desktop add-to-quote button*/}
                <div className="mt-40px">
                    <button className="btn btn-solid-green" id="AddToQuote" onClick={this.handleAcceptQuote}>
                        <span className="Add-to-quote">{"Add to quote"}</span>
                        <br />
                        <span className="QuoteTotal">{this.props.profile.currencySymbol} {this.props.sales.carPremium} pm</span>
                    </button>
                </div>

                <AcceptQuote premuim={this.props.sales.carPremium} />
            </div>
        );
    }
}


const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CodeRedQuotation);